import { render, staticRenderFns } from "./RegularAvatar.vue?vue&type=template&id=005c4c5c&"
import script from "./RegularAvatar.vue?vue&type=script&lang=js&"
export * from "./RegularAvatar.vue?vue&type=script&lang=js&"
import style0 from "./RegularAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports